import script from "./AssetDetailPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetDetailPanel.vue?vue&type=script&setup=true&lang=js"

import "./AssetDetailPanel.vue?vue&type=style&index=0&id=0fdc39eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fdc39eb"]])

export default __exports__